var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import SimpleDiagramBase from './SimpleDiagramBase';
import { prepareDiagramData2D } from '../basics/Statistics';
import { setOrDef } from '../Helpers';
import * as _ from 'lodash';
var Line = /** @class */ (function (_super) {
    __extends(Line, _super);
    function Line() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            data: undefined,
        };
        _this.calcData = function (props) {
            var d = props.diagram;
            var stacked = d.stacked ? true : false;
            prepareDiagramData2D(props.diagram, {
                type: "line",
                symbol: setOrDef(d, function (x) { return x.symbolType; }, "circle"),
                symbolSize: setOrDef(d, function (x) { return x.symbolSize; }, 8),
                lineStyle: {
                    type: setOrDef(d, function (x) { return x.lineType; }, "solid"),
                    width: setOrDef(d, function (x) { return x.lineWidth; }, 2),
                },
                stack: stacked ? "1" : undefined,
                areaStyle: d.area ? {
                    opacity: setOrDef(d.area, function (x) { return x.opacity; }, 50) / 100,
                } : undefined
            }).then(function (data) {
                //                console.log(data);
                _this.setState({ data: data });
                if (_this.props.onFieldsLoaded)
                    _this.props.onFieldsLoaded(data.fields);
            });
        };
        _this.shortenDate = function (data) {
            var d = data.toString();
            var idx = _.lastIndexOf(d, ".");
            if (idx >= 0)
                return d.substring(0, idx);
            return d;
        };
        _this.getOption = function () {
            if (!_this.state.data)
                return undefined;
            var sd = _this.state.data;
            //console.log(this.state.data);
            var d = _this.props.diagram;
            var series = _this.state.data.data.series;
            if (d.axisX && d.axisX.type === "time") {
                series = _.cloneDeep(_this.state.data.data.series);
                for (var i = 0; i < series.length; i++) {
                    var s = series[i];
                    var data = [];
                    for (var j = 0; j < s.data.length; j++) {
                        var d_1 = s.data[j];
                        data.push({ name: d_1.name, value: [_this.shortenDate(d_1.name), d_1.value] });
                    }
                    s.data = data;
                }
            }
            var option = __assign(__assign({ backgroundColor: d.backgroundColor, color: _this.props.diagram.colors ? _this.props.diagram.colors.colors : undefined, 
                // dataset: {
                //     source: this.state.data.data
                // },
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    axisPointer: d.showAxisPointer ? {
                        type: "shadow"
                    } : undefined
                }, grid: {
                    show: true,
                    left: setOrDef(d.margin, function (x) { return x.left; }, 20),
                    right: setOrDef(d.margin, function (x) { return x.right; }, 10),
                    bottom: setOrDef(d.margin, function (x) { return x.bottom; }, 20),
                    top: setOrDef(d.margin, function (x) { return x.top; }, 10),
                    containLabel: true,
                    backgroundColor: 'transparent',
                    borderWidth: 0
                } }, _this.getBaseOption()), { series: series });
            //console.log("diagram option =>", option);
            return option;
        };
        return _this;
    }
    Line.prototype.needRecalc = function (nextProps) {
        var res = _super.prototype.needRecalc.call(this, nextProps);
        var ndp = nextProps.diagram;
        var dp = this.props.diagram;
        res = res || (dp.lineType !== ndp.lineType);
        res = res || (dp.lineWidth !== ndp.lineWidth);
        res = res || (dp.symbolType !== ndp.symbolType);
        res = res || (dp.symbolSize !== ndp.symbolSize);
        return res;
    };
    return Line;
}(SimpleDiagramBase));
export default Line;
//# sourceMappingURL=Line.js.map